import { recoilPersist } from 'recoil-persist';

const { persistAtom } = recoilPersist();

export const persist = persistAtom;
